// The origin_tag the TAV-3420 Services Australia import writes. A client service carrying it is
// locked against local edits (it can still be removed). The TAV-3421 contributions import writes
// the same value, so it also marks an imported contribution. Kept apart from the column definitions so the
// source badge and the columns can both read it without importing each other.
export const ORIGIN_TAG_API = 'api';
